export default {
  namespaced: true,
  hikvision_master_accounts: {
    title: "hikvision Cuenta Maestra | hikvision Cuentas Maestras",
    name: "nombre",
    ip: "IP",
    app_key: "clave de aplicación",
    app_secret: "clave secreta de aplicación",
    port: 'puerto',
    dvrs: "DVR'S",
    syncSuccess: "sincronizado corretamente",
    syncDvrs: "Sincronizar DVR'S",
    admin_url: "Enlace de amdministación",
    hls_url: "Enlace de HLS",
    websocket_url: "Enlace de Websocket"
  },
};
